<template>
  <div>
    <div v-if="Array.isArray(item)">
      <language_input
        v-for="(value, index) in item"
        :key="index"
        :item="value"
        @mutate="$emit('mutate', $event)"
        :label="getDescriptionFromPath(path)"
        :path="[...path, index.toString()]"
      ></language_input>
    </div>
    <div v-else-if="typeof item === 'object'">
      <language_input
        v-for="(value, key) in item"
        :key="key"
        :item="value"
        @mutate="$emit('mutate', $event)"
        :path="[...path, key]"
      ></language_input>
    </div>
    <div v-else-if="typeof item === 'string'">
      <v-text-field
        v-model="localItem"
        :label="getDescriptionFromPath(path)"
      ></v-text-field>
    </div>
    <div v-else>Controllo non gestito {{ item }}</div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "language_input",
  computed: {
    localItem: {
      get() {
        return this.item;
      },
      set(value) {
        this.$emit("mutate", { value, path: this.path });
      },
    },
  },
  props: {
    item: null,
    path: Array,
  },
  methods: {
    getDescriptionFromPath(path) {
      return path[path.length - 1];
    },
  },
  beforeMount() {},
};
</script>
